import "core-js/modules/es6.regexp.search.js";
import { createAsyncAction } from "./utils";
export var getHighInterestBanks = createAsyncAction('getHighInterestBanks', function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$serverRequest = _ref.serverRequest,
      serverRequest = _ref$serverRequest === void 0 ? false : _ref$serverRequest,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 2 : _ref$limit,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  return {
    makeRequest: function makeRequest(state, opts) {
      var query = {
        query: [{
          field: 'offer.product.details.sub_product_type',
          type: 'eq',
          value: 'SAVINGS'
        }, {
          field: 'offer.product.details.priority',
          type: 'gt',
          value: 0
        }, {
          field: 'offer.details.display_pages',
          type: 'contains_one_of',
          value: ['IPX_CARDS']
        }],
        sort: [{
          field: 'offer.details.apy',
          order: 'desc'
        }, {
          field: 'offer.product.details.priority',
          order: 'asc'
        }],
        pagination: {
          offset: 0,
          limit: limit
        }
      };
      return opts.BankingProductsSDK.search(query, options, serverRequest);
    }
  };
});
export var getBanksByName = createAsyncAction('getBanksByName', function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$serverRequest = _ref2.serverRequest,
      serverRequest = _ref2$serverRequest === void 0 ? false : _ref2$serverRequest,
      _ref2$bankType = _ref2.bankType,
      bankType = _ref2$bankType === void 0 ? 'SAVINGS' : _ref2$bankType,
      _ref2$bankNames = _ref2.bankNames,
      bankNames = _ref2$bankNames === void 0 ? [] : _ref2$bankNames,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? {} : _ref2$options,
      _ref2$sort = _ref2.sort,
      sort = _ref2$sort === void 0 ? [] : _ref2$sort;

  return {
    makeRequest: function makeRequest(state, opts) {
      var query = {
        query: [{
          field: 'offer.product.details.sub_product_type',
          type: 'eq',
          value: bankType
        }, {
          type: 'or',
          value: [{
            field: 'offer.product.institution.name',
            type: 'in',
            value: bankNames
          }, {
            field: 'offer.product.institution.details.display_name',
            type: 'in',
            value: bankNames
          }]
        }],
        sort: sort
      };
      return opts.BankingProductsSDK.search(query, options, serverRequest);
    }
  };
});
export var getBanksByCertId = createAsyncAction('getBanksByCertId', function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$serverRequest = _ref3.serverRequest,
      serverRequest = _ref3$serverRequest === void 0 ? false : _ref3$serverRequest,
      _ref3$bankType = _ref3.bankType,
      bankType = _ref3$bankType === void 0 ? 'SAVINGS' : _ref3$bankType,
      _ref3$certIds = _ref3.certIds,
      certIds = _ref3$certIds === void 0 ? [] : _ref3$certIds,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? {} : _ref3$options,
      _ref3$sort = _ref3.sort,
      sort = _ref3$sort === void 0 ? [] : _ref3$sort;

  return {
    makeRequest: function makeRequest(state, opts) {
      var query = {
        query: [{
          field: 'offer.product.details.sub_product_type',
          type: 'eq',
          value: bankType
        }, {
          field: 'offer.product.institution.details.cert_id',
          type: 'in',
          value: certIds
        }],
        sort: sort
      };
      return opts.BankingProductsSDK.search(query, options, serverRequest);
    }
  };
});